type BrandedShareMessageOptions = {
  audioUrl?: string | null;
  origin: string;
  script: string;
};

function normalizeOrigin(origin: string) {
  return origin.replace(/\/+$/, "");
}

export function buildBrandedShareMessage({
  audioUrl,
  origin,
  script,
}: BrandedShareMessageOptions) {
  const appUrl = normalizeOrigin(origin);
  const audioLink = audioUrl
    ? new URL(audioUrl, `${appUrl}/`).toString()
    : null;
  const lines = ["🎙️ Hai ricevuto un Vaffangoogle", "", script.trim()];

  if (audioLink) {
    lines.push(
      "",
      `🔊 Ascolta il vocale: ${audioLink}`,
      "Il link audio resta disponibile per 24 ore.",
    );
  }

  lines.push(
    "",
    "Creato con Vaffangoogle — Dillo forte, senza dirlo male.",
    appUrl,
  );

  return lines.join("\n");
}
